import { createSelector } from 'reselect';
import createCachedSelector from 're-reselect';

const authorizedUser = state => state.auth.user;
const allIds = state => state.entities.user.allIds;
const byId = state => state.entities.user.byId;

export const getCurrentUser = createSelector(
  [authorizedUser, byId],
  (id, users) => {
    const user = id ? users[id] : null;
    if (!user) return null;
    return {
      ...user,
    };
  }
);

export const getCurrentUserRole = createSelector([getCurrentUser], user => {
  return user ? user.role : null;
});

export const getCurrentUserCompany = createSelector([getCurrentUser], user => {
  return user ? user.company : null;
});

export const getAllUsers = createSelector([byId, allIds], (users, ids) => {
  return ids.map(id => {
    const user = users[id];
    return {
      ...user,
    };
  });
});

export const getUserById = createCachedSelector(
  byId,
  (state, id) => id,
  (users, userId) => {
    return users[userId];
  }
)((state, id) => id);



// WEBPACK FOOTER //
// ./src/modules/user/user.selectors.js